import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

// Connects to data-controller="bip-search"
export default class extends Controller {
  static targets = ["dropdown", "selectedName", "input"];

  static values = {
    url: String,
    attribute: String,
    placeholder: { type: String, default: "-" },
  };

  connect() {
    this.$dropdown = $(this.dropdownTarget);
  }

  async select(ev) {
    ev.stopPropagation();

    const dropdownItem =
      ev.target.querySelector(".dropdown-item") ||
      ev.target.closest(".dropdown-item");

    if (ev.params.value.length === 0) {
      const elem = document.createElement("span");
      elem.classList.add("text-muted");
      elem.textContent = this.placeholderValue;

      this.selectedNameTarget.replaceChildren(elem);
    } else {
      this.selectedNameTarget.replaceChildren(dropdownItem.cloneNode(true));
    }

    try {
      this.$dropdown.dropdown("hide");
    } catch {
      // Old layout bootstrap version doesn't have a hide method...
      this.$dropdown.dropdown("toggle");
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = ev.params.value;
    }

    if (this.hasUrlValue) {
      this.$dropdown.LoadingOverlay("show");

      const formData = new FormData();
      formData.set(this.attributeValue, ev.params.value);

      const resp = await patch(this.urlValue, {
        body: formData,
        responseKind: "turbo-stream",
      });

      if (resp.ok) {
        this.$dropdown.LoadingOverlay("hide");
      } else {
        alert("Could not save changes, please try again.");
        window.location.reload();
      }
    }
  }
}
